import axios from 'axios'
import { FIELD_TYPES } from 'common/hooks/useForm'
import { maskFuntions } from 'src/features/price-policies/constants'
import { REACT_APP_API } from '../../config'


export default async function getAllBonification({carlotSelected=[], stateFilters=[], licencePlate=''}) {
  let query = ''
  stateFilters.forEach((filter)=> {
    if(filter.type === FIELD_TYPES.CHECKBOXES){
      query = query + `${filter.keyBackend}[]=${filter.value}&`
    } else {
      query = query + `${filter.keyBackend}=${maskFuntions.removeMask(filter.value)}&`
    }
  })
  carlotSelected.forEach((carLot)=> {
    query = query + `car_lot_id[]=${carLot}&`
  })
  if(licencePlate) { query = query + `licencePlate=${licencePlate}&` }
  query = query.slice(0,-1)
  

  const response = await axios(
    `${REACT_APP_API}/bonifications/used?${query}`,
  )
  
  return response?.data?.data || []
}